import {
    GETTRANSACTIONLISTREFUND_SUCCESS,
    GETTRANSACTIONLISTREFUND_FAILED,
    RESET_GETTRANSACTIONLISTREFUND,
    LOADING_GETTRANSACTIONLISTREFUND,
    NETWORK_ERROR_GETTRANSACTIONLISTREFUND,
} from "../types/index";

const initialState = {
    isLoading: false,
    success: false,
    network: false,
    failed: false,
    data: {},
    message: "",
    networkError: "",
};

export default (state = initialState, action) => {
    switch (action.type) {
        case LOADING_GETTRANSACTIONLISTREFUND:
            return {
                ...state,
                isLoading: true,
                success: false,
                failed: false,
                network: false,
                data: {},
                message: "",
                networkError: "",
            };
        case GETTRANSACTIONLISTREFUND_FAILED:
            return {
                ...state,
                isLoading: false,
                success: false,
                failed: true,
                network: false,
                data: action.payload,
                message: "",
                networkError: "",
            };
        case GETTRANSACTIONLISTREFUND_SUCCESS:
            return {
                ...state,
                isLoading: false,
                success: true,
                failed: false,
                network: false,
                data: action.payload,
                message: "",
                networkError: "",
            };
        case NETWORK_ERROR_GETTRANSACTIONLISTREFUND:
            return {
                ...state,
                isLoading: false,
                success: false,
                failed: false,
                network: true,
                data: {},
                message: "",
                networkError: "",
            };
        case RESET_GETTRANSACTIONLISTREFUND:
            return (state = initialState);
        default:
            return state;
    }
};
